import Header from "../componentes/Header";
import FinanceSection from "../componentes/FinanceSection";

function Finance() {
    return(
        <>
            <Header/>
            <FinanceSection/>
        </>
    )
}

export default Finance;